/* Hexabiome — client error reporter (v1.2, 2026-09-07)
 *
 * Why this exists: Clarity recorded 29 script errors over 3 days, 100% of them in
 * FacebookApp / InstagramApp webviews and 0 in Chrome, Safari, Samsung Internet or
 * desktop. The Data Export API returns counts only, never the message, and the error
 * does not reproduce in normal browsers — so the message has to be captured in the
 * webview itself and pushed into Clarity as a custom tag we can segment on.
 *
 * Constraints:
 *  - ES5 only. This runs in old in-app webviews; arrow functions / const / let are out.
 *  - Must never throw. A reporter that breaks the page it is measuring is worse than none.
 *  - Must never flood: capped per page view and deduped by message.
 *  - Loads synchronously and first, so listeners exist before any other script runs.
 */
(function () {
  'use strict';

  var MAX_REPORTS = 5;
  var sent = 0;
  var seen = {};

  window.__hexaErrors = window.__hexaErrors || [];

  function surface() {
    try {
      var ua = navigator.userAgent || '';
      if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1 || ua.indexOf('FB_IAB') > -1) {
        return 'facebook-webview';
      }
      if (ua.indexOf('Instagram') > -1) return 'instagram-webview';
      if (ua.indexOf('Line/') > -1) return 'line-webview';
      if (ua.indexOf('KAKAOTALK') > -1) return 'kakao-webview';
      return 'browser';
    } catch (e) {
      return 'unknown';
    }
  }

  function tag(key, value) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', key, String(value).slice(0, 255));
      }
    } catch (e) {
      /* Clarity not ready, blocked, or throwing — never surface it */
    }
  }

  function report(entry) {
    try {
      if (sent >= MAX_REPORTS) return;
      // Keyed on the message alone: the same fault thrown from several call sites would
      // otherwise be sent repeatedly and burn the per-page cap on one problem.
      var key = entry.message;
      if (seen[key]) return;
      seen[key] = 1;
      sent++;

      window.__hexaErrors.push(entry);

      tag('js_error', entry.message);
      tag('js_error_source', entry.filename + ':' + entry.lineno + ':' + entry.colno);
      tag('js_error_surface', entry.surface);
      tag('js_error_page', entry.page);

      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'js_error');
        }
      } catch (e) {}
    } catch (e) {
      /* reporting must never break the page */
    }
  }

  function normalize(message, filename, lineno, colno) {
    return {
      message: String(message == null ? 'unknown' : message).slice(0, 255),
      filename: String(filename == null ? '' : filename).slice(0, 255),
      lineno: lineno == null ? 0 : lineno,
      colno: colno == null ? 0 : colno,
      surface: surface(),
      page: (location && location.pathname) || '',
      at: new Date().toISOString()
    };
  }

  try {
    window.addEventListener('error', function (e) {
        try {
          // Resource load failures (img/script/link) arrive here with no e.message.
          if (e && e.target && e.target !== window && e.target.tagName) {
            var el = e.target;
            report(
              normalize(
                'resource-load-failed: ' + el.tagName.toLowerCase(),
                el.src || el.href || '',
                0,
                0
              )
            );
            return;
          }
          report(normalize(e && e.message, e && e.filename, e && e.lineno, e && e.colno));
        } catch (inner) {}
    }, true); // capture phase, so resource errors are seen too
  } catch (e) {}

  try {
    window.addEventListener('unhandledrejection', function (e) {
      try {
        var r = e && e.reason;
        var msg = r && r.message ? r.message : r;
        report(normalize('unhandledrejection: ' + msg, '', 0, 0));
      } catch (inner) {}
    });
  } catch (e) {}

  // Always tag the surface, error or not, so error rate can be read per surface.
  try {
    if (typeof window.clarity === 'function') {
      tag('surface', surface());
    } else {
      // Clarity loads async; tag once it appears, then stop looking.
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof window.clarity === 'function') {
          tag('surface', surface());
          clearInterval(timer);
        } else if (tries > 40) {
          clearInterval(timer);
        }
      }, 250);
    }
  } catch (e) {}
})();
